/**
 * ExtendedSummaryFields - Additional detail fields missing from the base detail pages
 * Ported from legacy requestingSummaryTab.jsx (40+ fields)
 */

import { OathSectionCard, OathDetailField } from '../../../shared/OathUI';
import { formatDate, formatAddress, formatPhoneNumber } from '../shared/formatUtils';

const ExtendedSummaryFields = ({ bondDetails, canViewPostingAgency, canViewRequestingAgency }) => {
  if (!bondDetails) return null;

  const hasPhysical = bondDetails.hairColor || bondDetails.eyeColor ||
    bondDetails.weight || bondDetails.height || bondDetails.placeOfBirth;

  const hasIdentifiers = bondDetails.xrefNumber || bondDetails.pfnNumber || bondDetails.jailInfo;

  const hasNextOfKin = bondDetails.nextOfKinName || bondDetails.nextOfKinPhoneNumber;

  const hasNearestRelative = bondDetails.nearestRelativeName;

  const hasAgencyInfo = (canViewPostingAgency && bondDetails.postingAgencyName) ||
    (canViewRequestingAgency && bondDetails.requestingAgencyName);

  return (
    <>
      {/* Physical Description */}
      {hasPhysical && (
        <OathSectionCard title="Physical Description" className="mb-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4">
            <OathDetailField label="Hair Color" value={bondDetails.hairColor} />
            <OathDetailField label="Eye Color" value={bondDetails.eyeColor} />
            <OathDetailField label="Weight" value={bondDetails.weight ? `${bondDetails.weight} lbs` : null} />
            <OathDetailField label="Height" value={bondDetails.height ? `${bondDetails.height} in` : null} />
            <OathDetailField label="Place of Birth" value={bondDetails.placeOfBirth} />
          </div>
        </OathSectionCard>
      )}

      {/* Additional Identifiers */}
      {hasIdentifiers && (
        <OathSectionCard title="Additional Identifiers" className="mb-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4">
            <OathDetailField label="XREF Number" value={bondDetails.xrefNumber} />
            <OathDetailField label="PFN Number" value={bondDetails.pfnNumber} />
            <OathDetailField label="Jail Info" value={bondDetails.jailInfo} />
          </div>
        </OathSectionCard>
      )}

      {/* Next of Kin */}
      {hasNextOfKin && (
        <OathSectionCard title="Next of Kin" className="mb-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4">
            <OathDetailField label="Name" value={bondDetails.nextOfKinName} />
            <OathDetailField label="Phone" value={formatPhoneNumber(bondDetails.nextOfKinPhoneNumber)} />
            <OathDetailField
              label="Address"
              value={formatAddress(
                bondDetails.nextOfKinAddress?.street1,
                bondDetails.nextOfKinAddress?.street2,
                bondDetails.nextOfKinAddress?.city,
                bondDetails.nextOfKinAddress?.state,
                bondDetails.nextOfKinAddress?.zipCode,
              )}
            />
          </div>
        </OathSectionCard>
      )}

      {/* Nearest Relative */}
      {hasNearestRelative && (
        <OathSectionCard title="Nearest Relative" className="mb-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4">
            <OathDetailField label="Name" value={bondDetails.nearestRelativeName} />
            <OathDetailField
              label="Address"
              value={formatAddress(
                bondDetails.nearestRelativeAddress?.street1,
                bondDetails.nearestRelativeAddress?.street2,
                bondDetails.nearestRelativeAddress?.city,
                bondDetails.nearestRelativeAddress?.state,
                bondDetails.nearestRelativeAddress?.zipCode,
              )}
            />
          </div>
        </OathSectionCard>
      )}

      {/* Agency Info */}
      {hasAgencyInfo && (
        <OathSectionCard title="Agency Information" className="mb-6">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4">
            {canViewPostingAgency && bondDetails.postingAgencyName && (
              <OathDetailField label="Posting Agency" value={bondDetails.postingAgencyName} />
            )}
            {canViewRequestingAgency && bondDetails.requestingAgencyName && (
              <OathDetailField label="Requesting Agency" value={bondDetails.requestingAgencyName} />
            )}
          </div>
        </OathSectionCard>
      )}
    </>
  );
};

export default ExtendedSummaryFields;
